module.exports = __webpack_public_path__ + "static/moore1-4b7344181a767167f3f5ab0d02f172a1.jpg";